module.exports = __webpack_public_path__ + "media/images/gender_overlay-7bd4ce98bcd6d227888cf10505efcea7.svg";